module.exports = __webpack_public_path__ + "img/manage-1.08a7cb81.png";